import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ItemPricingModel } from 'products-data';

@Component({
  selector: 'ideal-product-fees-view',
  imports: [CurrencyPipe],
  standalone: true,
  templateUrl: './product-fees-view.component.html',
  styleUrl: './product-fees-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFeesViewComponent {
  public readonly pricing = input<ItemPricingModel>();
  public readonly multiplyBy = input(1);

  protected readonly fees = computed(() =>
    (this.pricing()?.fees ?? []).map((fee) => ({
      ...fee,
      value: fee.value * this.multiplyBy() * (this.pricing()?.quantitySoldIn ?? 1),
    })),
  );
}
